import { textConstants } from 'constants/texts';
import { useAmplitude } from 'hooks/useAmplitude';
import { useSendTracking } from 'hooks/useSendTracking';
import { TProfileOpenedEventsProps } from './types';

const useProfileVisitedEvents = () => {
  const { sendAmplitude } = useAmplitude();
  const { sendTrackingJaiminho } = useSendTracking();

  const profileVisitedEvents = ({
    source,
    truckerId,
    codeRegion,
    isVerified,
    destiny,
    freightId,
    tag,
    latestConsultations,
  }: TProfileOpenedEventsProps) => {
    const commomData = {
      source,
      codeRegion,
      isVerified,
      latestConsultations,
      tag: tag || textConstants.notAvailaible,
      destiny: destiny || textConstants.notAvailaible,
    };

    sendAmplitude('trucker_listing_profile_visited', {
      ...commomData,
      truckerId,
      freightCode: freightId || textConstants.notAvailaible,
    });

    sendTrackingJaiminho(
      {
        nameEvent: 'trucker_listing_profile_visited',
        data: {
          ...commomData,
          truckerId: `hashed|${truckerId}`,
          freightId: freightId ? `hashed|${freightId}` : textConstants.notAvailaible,
        },
      },
      'trucker_profile'
    );
  };

  return { profileVisitedEvents };
};

export { useProfileVisitedEvents };
